import React from 'react'
import styles from './styles.css'
import {Form, Field} from 'simple-react-form'
import PropTypes from 'prop-types'
import Text from 'orionsoft-parts/lib/components/fields/Text'
import Email from 'App/components/fields/Email'
import Rut from 'App/components/fields/Rut'
import Save from './Save'
import withOrganization from 'App/Decorators/withOrganization'
import MdBackup from 'react-icons/lib/md/backup'

@withOrganization
export default class Create extends React.Component {
  static propTypes = {
    organizationId: PropTypes.string
  }

  state = {}

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className="col-xs-12 col-sm-7">
                <h3 className={styles.title}>Crear preparación para documento Security Sat</h3>
              </div>
              <div className="col-xs-12 col-sm-5 end-md">
                <div className={styles.icon}>
                  <MdBackup />
                </div>
              </div>
            </div>
          </div>
          <div className="content">
            <div className={styles.form}>
              <Form state={this.state} onChange={changes => this.setState(changes)}>
                <div className={styles.field}>
                  Nombre del documento:
                  <Field fieldName="preparationName" type={Text} />
                </div>
                <div className={styles.field}>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4">
                      Nombres del Cliente o Razón social
                      <Field fieldName="clientNames" type={Text} />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                      Apellido Paterno Cliente
                      <Field fieldName="clientLFName" type={Text} />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                      Apellido Materno Cliente
                      <Field fieldName="clientLMName" type={Text} />
                    </div>
                  </div>
                </div>
                <div className={styles.field}>
                  <div className="row">
                    <div className="col-xs-12 col-sm-4">
                      Email del Cliente<br />
                      <Field fieldName="clientEmail" type={Email} />
                    </div>
                    <div className="col-xs-12 col-sm-4">
                      Rut del Cliente<br />
                      <Field fieldName="clientRut" type={Rut} />
                    </div>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
        <Save value={this.state} organizationId={this.props.organizationId} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/Create/index.js